import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MediaService from "../../../services/KangarooServices/MediaServices";
import { useFormik } from "formik";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import MediaModal from "../../PagesSection/Component/MediaModal";
import NewsService from "../../../services/KangarooServices/NewsService";
import * as Yup from "yup";

const NewsForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [mediaData, setMediaData] = useState([]);
  const [detailData, setDetailData] = useState({});
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);

  const toggleMedia = () => setIsMediaOpen(!isMediaOpen);

  // Fetch media list
  const fetchMedia = async (page = 1, size = 1000) => {
    try {
      const response = await MediaService.getList({ page, pageSize: size });
      setMediaData(response);
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch page detail
  const fetchPageDetail = async () => {
    try {
      const response = await NewsService.getDetail(id);
      setDetailData(response);

      setSelectedMedia(response?.featuredMedia);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchMedia();
    if (id) fetchPageDetail();
  }, [id]);

  // Validation Schema
  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    fullText: Yup.string().nullable(),
    shortDescription: Yup.string().required("Short description is required"),
    category: Yup.string().nullable(),
    sourceLink: Yup.string().url("Invalid URL").nullable(),
  });

  const formik = useFormik({
    initialValues: {
      title: detailData?.title || "",
      fullText: detailData?.fullText || "",
      shortDescription: detailData?.shortDescription || "",
      category: detailData?.category || "",
      sourceLink: detailData?.sourceLink || "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      try {
        // Build payload
        const payload = {
          title: values.title,
          fullText: values.fullText,
          shortDescription: values.shortDescription,
          featuredMediaId: selectedMedia?.id || null,
          category: values.category,
          sourceLink: values.sourceLink,
        };

        if (id) {
          await NewsService.update(id, payload);
          toast.success("News updated successfully");
        } else {
          await NewsService.create(payload);
          toast.success("News created successfully");
        }

        navigate("/news");
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const breadcrumbItems = [{ title: "Back to List", link: "/news" }];

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="News Form"
          pageTitle="News"
          breadcrumbItems={breadcrumbItems}
        />

        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {id ? "Update" : "Create"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => navigate("/news")}
            >
              Cancel
            </button>
          </div>

          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <Label>
                      Title <span className="text-danger">*</span>
                    </Label>
                    <Input
                      name="title"
                      value={formik.values.title}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.title && formik.errors.title && (
                      <div className="text-danger mt-1">
                        {formik.errors.title}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label>Sub Text</Label>
                    <Input
                      name="fullText"
                      value={formik.values.fullText}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.fullText && formik.errors.fullText && (
                      <div className="text-danger mt-1">
                        {formik.errors.fullText}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label>
                      Short Description <span className="text-danger">*</span>
                    </Label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formik.values.shortDescription}
                      onChange={(event, editor) =>
                        formik.setFieldValue(
                          "shortDescription",
                          editor.getData()
                        )
                      }
                    />
                    {formik.touched.shortDescription &&
                      formik.errors.shortDescription && (
                        <div className="text-danger mt-1">
                          {formik.errors.shortDescription}
                        </div>
                      )}
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col lg={4}>
              <Card>
                <CardBody>
                  {/* <div className="d-flex justify-content-between align-items-center">
                    <Label style={{ cursor: "pointer" }}>Media</Label>
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      onClick={toggleMedia}
                    >
                      +
                    </button>
                  </div> */}
                  <Label style={{ cursor: "pointer" }}>Media</Label>

                  {selectedMedia ? (
                  
                    <div className="d-flex flex-column align-items-center gap-3 p-3 border rounded shadow-sm bg-light">
                      {/* Thumbnail */}
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "10px",
                          overflow: "hidden",
                          border: "1px solid #ddd",
                          flexShrink: 0,
                        }}
                      >
                        <img
                          src={`${imageBaseApi}${selectedMedia?.url}`}
                          alt="media"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "transform .2s",
                          }}
                          className="hover-zoom"
                        />
                      </div>

                      {/* Media Info + Actions */}
                      <div className="d-flex flex-column justify-content-between">
                        <div className="">
                          <div className="fw-semibold text-break">
                            {selectedMedia?.fileName || "Media File"}
                          </div>

                          {/* SIZE INFO */}
                          {selectedMedia?.size && (
                            <small className="text-muted">
                              Size: {(selectedMedia.size / 1024)?.toFixed(1)} KB
                            </small>
                          )}
                        </div>

                        <div className="d-flex gap-2 mt-2">
                          <Button
                            size="sm"
                            color="primary"
                            outline
                            className="rounded-pill px-3"
                            onClick={toggleMedia}
                          >
                            Change
                          </Button>

                          <Button
                            size="sm"
                            color="danger"
                            outline
                            type="button"
                            className="rounded-pill px-3"
                            onClick={() => {
                              setSelectedMedia(null);
                            }}
                          >
                            <i className="ri-delete-bin-5-line me-1"></i>
                            Remove
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center p-4 border rounded bg-light">
                      <i className="ri-image-add-line fs-1 text-secondary"></i>
                      <h6 className="mt-2 mb-2 text-muted">No media added</h6>
                      <h6 className="mb-3 text-muted">1200 x 630</h6>

                      <Button
                        outline
                        size="sm"
                        color="secondary"
                        className="rounded-pill px-3"
                        onClick={toggleMedia}
                      >
                        <i className="ri-image-add-line me-1"></i> Add Media
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>

              <Card className="mt-3">
                <CardHeader>Meta Data</CardHeader>
                <CardBody>
                  <div className="mb-3">
                    <Label>Category</Label>
                    <Input
                      name="category"
                      value={formik.values.category}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.category && formik.errors.category && (
                      <div className="text-danger mt-1">
                        {formik.errors.category}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Label>Source Link</Label>
                    <Input
                      name="sourceLink"
                      type="textarea"
                      rows={3}
                      value={formik.values.sourceLink}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.sourceLink && formik.errors.sourceLink && (
                      <div className="text-danger mt-1">
                        {formik.errors.sourceLink}
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </form>
      </div>

      <MediaModal
        isOpen={isMediaOpen}
        toggle={toggleMedia}
        mediaData={mediaData}
        selectedMedia={selectedMedia}
        setSelectedMedia={setSelectedMedia}
      />
    </Container>
  );
};

export default NewsForm;
